export const LineItemRoutesName = {
  EDIT_LINE_ITEM: 'edit-entity-line-item',
};

export const LineItemDetailsTabConstants = {
  OVERVIEW: 'overview',
  TASKS: 'tasks',
  FILES: 'files',
  FLIGHTS: 'flights',
};

export const EntityLineItemListName = 'Line Items';

export const EntityLevelLineItemListName = {
  LINE_ITEM: 'line_item',
  ORDER_LEVEL_LINE_ITEM: 'order_level_line_item',
};

export const Event = {
  APPLY_FILTERS: 'apply-filters',
  CLEAR_FILTERS: 'clear-filters',
  INPUT: 'input',
  UPDATE_LINE_ITEM_STATUS: 'update-line-item-status',
  UPDATE_ORDER_DETAILS: 'update-order-details',
};

export const LineItemFields = {
  ID: 'id',
  NAME: 'name',
  DISPLAY_NAME: 'display_name',
  SELECT_PLACEHOLDER: 'Select',
  CLIENT: 'Client',
  ORDER_CLIENT_ID: 'order_client_id',
  ORDER: 'Order',
  ORDER_ID: 'order_id',
  PRODUCT: 'Product',
  FORM_ID: 'form_id',
  STATUS_TITLE: 'Line Item Status',
  STATUS_FIELD: 'status',
  START_DATE_TITLE: 'Start Date',
  START_DATE_FIELD: 'start_date',
  END_DATE_TITLE: 'End Date',
  END_DATE_FIELD: 'end_date',
  TOTAL_BUDGET: 'total_budget',
  CREATED_BY: 'Created By',
  CREATED_BY_USER_ID: 'created_by_user_id',
  GOAL: 'goal',
  GOAL_TRACKING: 'Goal Tracking',
  ON_TRACK_KEY: 'on_track',
  ON_TRACK_VALUE: 'On Track',
  OFF_TRACK_KEY: 'off_track',
  OFF_TRACK_VALUE: 'Off Track',
  WITHIN_THRESHOLD_KEY: 'within_threshold',
  WITHIN_THRESHOLD_VALUE: 'Within Threshold',
  TOTAL_BUDGET_TITLE: 'Total Budget',
  FIELDS: 'fields',
  LINE: 'line',
  CLIENT_IDS: 'client_ids',
  FILES: 'Files',
  __OVERRIDDEN: '__OVERRIDDEN',
  __OVERRIDE: '__OVERRIDE',
};

export const HasGoalsConstants = {
  YES: 'yes',
  NO: 'no',
};

export const LineItemRoute = 'entity/lineitems';

export const CLASSIC_VIEW_LINE_ITEM_URL = '/client/iotool/dist/#/items/viewLineItem';

export const LineItemRoutePathName = 'lineitems';

export const DEFAULT_LINE_ITEM_LIST_SORT_QUERY = '-created_at,-id';
